import React from 'react';

const ContactPage = () => {
    return (
        <div>
            <h1>Contact Us</h1>
            <p>If you have any questions, feel free to reach out!</p>
            <p><strong>Email:</strong> contact@movieflix.com</p>
            <p><strong>Phone:</strong> +91 123 456 7890</p>
        </div>
    );
};

export default ContactPage;